/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, bool, string,
    func, array,
} from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import Loading from '../../common/Loading';
import GiftListUser from './GiftListUser';
import RegularUser from './RegularUser';
import GiftListLogin from './GiftListLogin';
import { queryVariables } from '../../utils/queryURL';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import { isEmpty } from '../../utils/object';
import Helper from '../../state/reducers/Helper';
import { getContactId } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getShopTheSite, deleteShopTheSiteStorage } from '../../utils/shopTheSite';
import { main as mainStyle } from '../../style/main';
import configENV from '../../config';
import { trackPage } from '../../../../helpers/tracking/common/commonTrackingHelpers';
import GraphqlSeoHeadTags from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import GiftListLandingPage from './GiftListLandingPage';
import GiftListUserV2 from './GiftListV2/GiftListUserV2';
import withPageView from '../../../../helpers/tracking/hocs/withPageView';
import WithRegisteredRecommendations from './WithRegisteredRecommendations';

const { PERSIST_KEY } = configENV;
let isPageReady = false;
const styles = ({ typography, palette }) => mainStyle(typography, palette);
class GiftList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectURL: '',
            params: queryVariables(),
            tokenLookup: 0,
            maxRetry: 10,
            // readyState: false,
        };
    }

    componentDidMount = () => {
        const { contactId } = this.props;
        const { refechGiftListOnPageLoad } = this;

        // Refeching Gift List data after returning from Shop the Site
        // then delete ShopTheSite storage
        const shopTheSiteObject = getShopTheSite(contactId);
        if (typeof shopTheSiteObject === 'object' && isEmpty(shopTheSiteObject)) {
            deleteShopTheSiteStorage(contactId);
        }

        // use of this function here to update recommendation gift list without page reload
        refechGiftListOnPageLoad();
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const { redirectURL } = this.state;
        isPageReady = true;
        try {
            const {
                pageData: { url },
            } = props;

            if (redirectURL) {
                this.setState({ redirectURL: '' }, () => props.history.push(redirectURL));
            }

            if (
                props.location.pathname
                && url
                && props.location.pathname !== url
            ) {
                this.setState({ redirectURL: url });
                props.handleRemoveRedirect();
            }
            // eslint-disable-next-line no-empty
        } catch (ex) { }
    };

    refechGiftListOnPageLoad = () => {
        const {
            match: {
                params: { id },
            },
            setReadyFetchingState,
            orderId,
            isAuthenticated,
            fetchGiftListsOnPageLoad,
            accessToken,
        } = this.props;

        const { maxRetry, tokenLookup, params } = this.state;

        if (!accessToken && tokenLookup <= maxRetry) {
            this.setState({ tokenLookup: tokenLookup + 1 }, () => {
                setTimeout(() => {
                    setReadyFetchingState();
                    this.refechGiftListOnPageLoad();
                }, 500);
            });
        } else if (!params.cstatus) {
            if (isAuthenticated) {
                fetchGiftListsOnPageLoad(id, orderId);
            } else {
                setReadyFetchingState();
            }
        }

        // Set ready state condition to avoid loading for none Gift List user
        // It's a temporay solution for now, but this will be removed
        // when backend could provide an API to indentify whether it's a Gift List user or not
        setTimeout(() => {
            const { isGiftListLoaded } = this.props;
            if (!isGiftListLoaded) {
                const custNbr = Helper.getSessionStorageObject('common', 'custNbr', false);
                // Get the custNbr from session to determind the Gift List user registration flow
                // If custNbr === 'GIFT-LIST-CUSTOMER-NUMBER', we won't set the readyState and wait for the big query API response
                // If custNbr === {}, we'll force the readyState to true in 7 seconds admitting the empty giftlist => users manually enter their customer number and zip code to link their account to Gift List
                if (typeof custNbr === 'object' && isEmpty(custNbr)) {
                    this.setState({ readyState: true });
                }
            }
        }, 7000);
    };

    giftListTemplate = () => {
        // eslint-disable-next-line object-curly-newline
        const {
            isGiftListLoaded,
            occasionId,
            recipients,
            isGiftListUser,
            occasions,
            // isReadyState,
            isAuthenticated,
            featureFlags,
            flags,
        } = this.props;

        const {
            params: { cstatus = 'E', custNbr, indivId },
            readyState,
        } = this.state;
        let hasItemInCart;

        if (recipients[occasionId]) {
            hasItemInCart = recipients[occasionId].filter((item) => item.addToCart !== '' && item.type === 'link').length > 0;
        }
        const hasProductInRec = recipients[occasionId]?.[0]?.products || [];

        // if (!isPageReady) return null;
        if (cstatus && custNbr && indivId) {
            // Verification Code landing page
            return (
                <GiftListLandingPage
                    cStatus={cstatus}
                    custNbr={custNbr}
                    indivId={indivId}
                    featureFlags={featureFlags}
                />
            );
        } if (isAuthenticated) {
            // Show loading screen while waiting for response of big query API
            if (!isGiftListLoaded && !readyState) { return <Loading pageTitle="Gift List" url="/account" />; }

            // Show loading screen while waiting for response after enter customerNumber/ZipCode
            // if (!isReadyState) {
            //     return <Loading pageTitle="Gift List" url="/account" />;
            // }

            if (isGiftListUser && hasProductInRec?.length > 0) {
                if (
                    !isEmpty(occasions)
                    || occasionId
                    || recipients[occasionId]
                ) {
                    // Show Gift List recipient template
                    return (
                        <>
                            {featureFlags['is-giftlist-registered-vertex-recs-enabled'] && (
                                <WithRegisteredRecommendations occasionId={occasionId} occasions={occasions} recipients={recipients} />
                            )}
                            {featureFlags['is-giftlist-v2-enabled'] && flags?.experimentGiftListV2 === 'variant'
                                ? (
                                    <GiftListUserV2
                                        // eslint-disable-next-line react/jsx-props-no-spreading
                                        {...this.props}
                                        hasItemInCart={hasItemInCart}
                                        refechGiftListOnPageLoad={this.refechGiftListOnPageLoad}
                                    />
                                ) : (
                                    <GiftListUser
                                        // eslint-disable-next-line react/jsx-props-no-spreading
                                        {...this.props}
                                        hasItemInCart={hasItemInCart}
                                        refechGiftListOnPageLoad={this.refechGiftListOnPageLoad}
                                        disablePageView
                                    />
                                )}
                        </>
                    );
                }
            } else {
                // Show regular user template if no occasions list
                return (
                    <RegularUser disablePageView />
                );
            }
        }
        // Return Gift List login screen if user is not authenticated
        return <GiftListLogin disablePageView isPageReady={isPageReady} />;
    };

    renderSeo = () => (
        <GraphqlSeoHeadTags seoData={{
            page_title: 'My Account',
            location: { pathname: '/account/gift-list' },
        }}
        />
    )

    render() {
        const { accessToken } = this.props;
        if (accessToken) isPageReady = true;

        return (
            <>
                {accessToken ? (
                    <>
                        {this.renderSeo()}
                        {this.giftListTemplate()}
                    </>
                ) : (
                    <Loading />
                )}
            </>
        );
    }
}

GiftList.defaultProps = {
    isGiftListLoaded: false,
    isBigGiftlist: false,
    occasions: [],
    contactId: '',
    recipients: {},
    isGiftListUser: false,
    occasionId: '',
    match: {},
    history: {},
    accessToken: '',
    orderId: '',
    flags: {},
};

GiftList.propTypes = {
    // fetchEmailAddressFromId: func.isRequired,
    isGiftListLoaded: bool,
    isBigGiftlist: bool,
    match: object,
    history: object,
    location: object.isRequired,
    contactId: string,
    featureFlags: object.isRequired,
    orderId: string,
    accessToken: string,
    occasionId: string,
    occasions: array,
    recipients: object,
    isGiftListUser: bool,
    fetchGiftListsOnPageLoad: func.isRequired,
    setReadyFetchingState: func.isRequired,
    handleRemoveRedirect: func.isRequired,
    isReadyState: bool.isRequired,
    isAuthenticated: bool.isRequired,
    flags: object,
};

export const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    const orderId = state?.checkout && state.order
        ? state.order.orderId
        : '';
    const accessToken = state?.member?.auth?.accessToken || '';
    const isAuthenticated = state?.member?.auth?.isAuthenticated;
    return {
        orderId,
        accessToken,
        isAuthenticated,
        contactId: getContactId(state),
        toggleState: newState.toggleState,
        pageData: newState.pageData,
        modal: newState.modal,
        isGiftListUser: newState.giftList.isGiftListUser,
        isGiftListLoaded: newState.giftList.isGiftListLoaded,
        isBigGiftlist: newState.giftList.isBigGiftlist,
        recipients: newState.giftList.recipients,
        occasionId: newState.giftList.occasionId,
        occasions: newState.giftList.occasions,
        currentPage: newState.giftList.currentPage,
        totalPage: newState.giftList.totalPage,
        isReadyState: newState.isReadyState,
    };
};

export const mapDispatchToProps = (dispatch) => ({
    fetchGiftListsOnPageLoad: (id, orderId) => dispatch(EventDispatcher.fetchGiftListsOnPageLoad(id, orderId)),
    setReadyFetchingState: () => dispatch(EventDispatcher.setReadyFetchingState()),
    handleRemoveRedirect: () => dispatch(EventDispatcher.handleRemoveRedirect()),
});

const enhance = compose(
    withLDConsumer(),
    trackPage({
        type: 'giftlist',
        name: 'GiftList',
        accountPage: true,
    }),
    withRouter,
    withStyles(styles, { withTheme: true }),
    connect(mapStateToProps, mapDispatchToProps),
    withPageView({
        pageViewSuccessTest: () => true,
    }),
);

export default enhance(GiftList);
